import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../contexts/AuthContext";
import { supabase } from "../../lib/supabase";
import { queryKeys } from "../../lib/queryKeys";
import { Tag } from "../../types";

export async function fetchTags(): Promise<Tag[]> {
  const { data, error } = await supabase
    .from("tags")
    .select("*")
    .order("created_at", { ascending: true });
  if (error) throw error;
  return (data ?? []) as Tag[];
}

export function useTags() {
  const { user } = useAuth();
  return useQuery({
    queryKey: queryKeys.tags,
    queryFn: fetchTags,
    enabled: !!user,
  });
}
